<template>
  <v-container v-if="$route.name === names.SURVEYS.PREVIEW" ref="mainContainer">
    <v-row class="justify-center">
      <v-col md="10" lg="8" sm="12" xl="8">
        <v-stepper v-model="select_stage" flat v-if="stages.length > 0">
          <v-card
              outlined
              style="word-break: inherit !important;"
          >
            <div class="stepper-header-scroll" ref="stepperScrollContainer">
              <v-stepper-header>
                <v-stepper-step
                  v-for="(stage, sindex) in stages"
                  :key="`stage-${sindex}`"
                  :complete="select_stage > sindex+1"
                  :step="`${sindex+1}`"
                >
                </v-stepper-step>
              </v-stepper-header>
            </div>
            <v-progress-linear v-show="loading" absolute indeterminate></v-progress-linear>
            <v-stepper-items>
              <v-stepper-content
                  v-for="(stage, sindex) in stages"
                  :key="`stage-${sindex}`"
                  :step="`${sindex+1}`"
              >
                <v-card
                    color="#f0f0f0"
                    flat
                    style="word-break: inherit !important;"
                >
                  <v-card-title class="text-pre-wrap" style="word-break: inherit !important;">
                    {{stage.title}}
                  </v-card-title>
                  <v-card-subtitle align="left" v-if="stage.description" class="text-pre-wrap">
                    {{stage.description}}
                  </v-card-subtitle>
                </v-card>

                <template
                    v-for="field in fields"
                >
                  <FieldView
                      v-if="field.answer"
                      v-model="field.answer.value"
                      :ref="`stage_${stage.id}_field_${field.id}`"
                      :key="`stage_${stage.id}_field_${field.id}_key`"
                      :field="field"
                      :survey="true"
                      :errors="getErrors(field)"
                      @focus="removeErrors(field)"
                      @download="downloadFieldFile"
                      :loading="loading"
                  ></FieldView>
                </template>
              </v-stepper-content>
            </v-stepper-items>
            <v-card-actions>
              <v-alert type="error" v-if="getError('attempt')" >
                {{ getError('attempt') }}
              </v-alert>
              <v-btn
                  v-if="!isFirstStage"
                  outlined
                  :color="!!errors.length? 'error' : ''"
                  @click="prevStep()"
              >
                Назад
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                  outlined
                  :color="!!errors.length? 'error' : ''"
                  @click="nextStep()"
                  v-if="!isLastStage"
              >
                Вперёд
              </v-btn>
              <v-btn
                  v-else
                  :color="!!errors.length? 'error' : 'success'"
                  @click="exitAttempt()"
              >
                Завершить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
  <router-view v-else></router-view>
</template>

<script>
import names from "../routers/names";
import TitledPageMixin from "../../../mixins/TitledPageMixin";
import {mapActions} from "vuex";
import FieldView from "../../templates/FieldView";
import selectors from "@/urls/selectors";
import helper from "@/urls/helper";
import {nextTick} from "vue";

export default {
  mixins: [TitledPageMixin],
  name: "SurveyingPreview",
  components: {
    FieldView
  },
  data(){
    return {
      timerId:0,
      page_title: "Прохождение опроса",
      select_stage: 1,
      close_attempt_flag: false,
      close_info_flag: false,
      fields: [],
      errors: [],
      stages: [],
      answers : [],
      attempt: this.$route.params.attempt,
      loading: false,
      has_error: true,
    }
  },
  computed: {
    names: () => names,
    select_stage_object() {
      return this.stages[this.select_stage - 1]
    },
    stage_fields() {
      return this.stages.length > 0 ? this.fields.filter(el => el.stage === this.select_stage_object) : []
    },
    isLastStage() {
      return this.select_stage === this.stages.length
    },
    isFirstStage() {
      return this.select_stage === 1
    }
  },
  watch: {
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
    select_stage(newVal) {
      this.$nextTick(() => {
        this.scrollToStep(newVal);
      });
    },
  },
  methods: {
    ...mapActions({
      loadStageList: 'creator/loadStageList',
      listStageField: 'creator/listStageField',
      sendEndAttempt: 'surveying/endAttempt',
      saveAnswers: 'surveying/SurveyingSave'
    }),
    getError: function (field) {
      for (let val in this.errors){
        let ss =  (this.errors[val])
        if(ss[field]){
          return ss[field]
        }
      }
      return null;
    },
    downloadFieldFile(field){
      let get = {}
      if (field.get_params.key)
        get['key'] = field.get_params.key
      let url = helper.getSurveyUrlWithParameters(field.name,field.action,{id: field.params.id}, get)
      if (url) window.open(url,'_blank');
    },
    getErrors(field){
      let error = this.errors.find(el => el.field === field.id)
      return error ? error.error : undefined
    },
    removeErrors(field){
      let error = this.errors.findIndex(el => el.field === field.id)
      if (error)
        this.errors.splice(error, 1)
    },
    wrappedLoadStageFieldList(){
      this.setLoading();

      this.listStageField({
        survey_id: this.$route.params.idSurvey,
        stage_id: this.select_stage_object.id,
        finalizer: (value) => {
          this.fields = value
          this.fields.forEach(el => {
            el.choices = el.choices_list
            el.answer = {}
            if (!el.answer.value){
              el.answer.value = el.default_value ? el.default_value : el.answer.value
            }
          })
          this.setNotLoading();
        }
      })
    },
    validate() {
      return true;
    },
    setLoading(){
      this.loading = true;
    },
    setNotLoading(){
      this.loading = false;
    },
    initialize() {
      this.setLoading();
      this.loadStageList({
        survey_id: this.$route.params.idSurvey,
        finalizer: (val) => {
          this.stages = val
          this.wrappedLoadStageFieldList();
        }
      })
    },
    scrollToTop(){
      this.$nextTick(() =>{
        const contentStart = this.$refs.mainContainer
        if (contentStart) {
          contentStart.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      })
    },
    prevStep () {
      if (!this.isFirstStage) {
          this.select_stage -= 1
          this.wrappedLoadStageFieldList()
      }
      this.scrollToTop()
    },
    nextStep () {
      if (!this.isLastStage) {
          this.select_stage += 1
          this.wrappedLoadStageFieldList();
      }
      this.scrollToTop()
    },
    exitAttempt() {
      this.$router.push({name: names.SURVEYS.DETAIL, params: {idSurvey: this.$route.params.idSurvey}})
    },
    scrollToStep(stepNumber) {
      if (!this.$refs.stepperScrollContainer) return;

      const stepIndex = stepNumber - 1;
      const container = this.$refs.stepperScrollContainer;
      const steps = container.querySelectorAll('.v-stepper__step');

      if (steps[stepIndex]) {
        const step = steps[stepIndex];
        const containerRect = container.getBoundingClientRect();
        const stepRect = step.getBoundingClientRect();

        const scrollLeft = container.scrollLeft;
        const targetScroll = scrollLeft + (stepRect.left - containerRect.left) - (containerRect.width / 2) + (stepRect.width / 2);

        const maxScroll = container.scrollWidth - container.clientWidth;
        const finalScroll = Math.max(0, Math.min(targetScroll, maxScroll));
        container.scrollTo({
          left: finalScroll,
          behavior: "smooth"
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToStep(this.select_stage);
    });
  },
  created() {
    this.initialize()
  }
}
</script>

<style scoped>
.stepper-header-scroll {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
  padding: 8px 0;
}

.v-stepper__header {
  flex-wrap: nowrap !important;
  height: 72px !important;
  box-shadow: none !important;
  padding: 0 16px !important;
  min-width: min-content !important;
}

.v-stepper__step {
  min-width: 60px !important;
  flex-shrink: 0 !important;
  transition: all 0.3s ease;
  border-radius: 4px;
  display: flex;
  justify-content: center !important;
}

.stepper-step--selected {
  background-color: rgba(25, 118, 210, 0.12) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
